import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "program-grid" }
const _hoisted_4 = { class: "program-card" }
const _hoisted_5 = { style: {"margin-top":"1rem"} }
const _hoisted_6 = { class: "program-card" }
const _hoisted_7 = { style: {"margin-top":"1rem"} }
const _hoisted_8 = { class: "cta" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "cta-buttons" }


export default /*@__PURE__*/_defineComponent({
  __name: 'GetInvolvedView',
  setup(__props) {

// Get Involved view - static content

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _cache[15] || (_cache[15] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("div", { class: "hero-content" }, [
        _createElementVNode("h2", null, "Get Involved"),
        _createElementVNode("p", null, "Join us in empowering the next generation of innovators")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Make a Difference", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", null, "There are many ways to support Space Coast STEM and help students in Brevard County gain access to technology and STEM education. Whether you have time, resources, or expertise to share, we'd love to have you join our mission.", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Volunteer Your Time", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, "Help us refurbish computers, mentor students, or assist with events. We need volunteers with all kinds of skills and backgrounds.", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Opportunities:")
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("ul", null, [
              _createElementVNode("li", null, "Computer refurbishment technicians"),
              _createElementVNode("li", null, "Mentors for students"),
              _createElementVNode("li", null, "Event coordinators and support staff"),
              _createElementVNode("li", null, "Administrative assistance")
            ], -1)),
            _createElementVNode("p", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/volunteer",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Sign Up as a Volunteer", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Support Our Mission", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", null, "You can help us provide more laptops to students in need through financial contributions or equipment donations.", -1)),
            _createElementVNode("p", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/donate",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Learn About Donating", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"program-card\" data-v-4f97d468><h3 data-v-4f97d468>Corporate Partnerships</h3><p data-v-4f97d468>Businesses can support Space Coast STEM through sponsorships, employee giving programs, equipment donations, or by hosting student field trips and job shadowing opportunities.</p><p data-v-4f97d468><strong data-v-4f97d468>Partnership benefits:</strong></p><ul data-v-4f97d468><li data-v-4f97d468>Community impact and visibility</li><li data-v-4f97d468>Employee engagement opportunities</li><li data-v-4f97d468>Tax-deductible contributions</li><li data-v-4f97d468>Connection with future workforce</li></ul></div><div class=\"program-card\" data-v-4f97d468><h3 data-v-4f97d468>School Partnerships</h3><p data-v-4f97d468>We work closely with schools throughout Brevard County to identify students who would benefit from our laptop programs.</p><p data-v-4f97d468><strong data-v-4f97d468>For educators:</strong></p><ul data-v-4f97d468><li data-v-4f97d468>Refer students to our programs</li><li data-v-4f97d468>Collaborate on STEM initiatives</li><li data-v-4f97d468>Sign up for portal access to manage requests</li></ul><p style=\"margin-top:1rem;\" data-v-4f97d468><a href=\"https://portal.spacecoaststem.org/login?signup=true\" class=\"btn btn-primary\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-4f97d468>Teacher Portal Sign Up</a></p></div><div class=\"program-card\" data-v-4f97d468><h3 data-v-4f97d468>Spread the Word</h3><p data-v-4f97d468>Help us reach more students and supporters by sharing our mission with your network, on social media, and in your community.</p><p data-v-4f97d468><strong data-v-4f97d468>How to help:</strong></p><ul data-v-4f97d468><li data-v-4f97d468>Share our website and programs</li><li data-v-4f97d468>Tell families about our services</li><li data-v-4f97d468>Connect us with potential donors</li><li data-v-4f97d468>Attend and promote our events</li></ul></div>", 3))
        ])
      ])
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("section", { class: "content-section requirements-section" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("h2", null, "Volunteer Requirements"),
        _createElementVNode("p", null, "All volunteers who work directly with students must:"),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, "Complete a volunteer application"),
          _createElementVNode("li", null, "Pass a background check"),
          _createElementVNode("li", null, "Attend a brief orientation session"),
          _createElementVNode("li", null, "Commit to a minimum time period (varies by role)")
        ]),
        _createElementVNode("p", null, "We provide training and support for all volunteer positions. No prior experience with technology or education is required for many roles - just enthusiasm and a desire to help students succeed!")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Ready to Get Started?", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", null, "Contact us to learn more about volunteer opportunities, donations, or partnerships", -1)),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/volunteer",
            class: "btn btn-primary"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Volunteer Today", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Contact Us", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})